export const endpoint = {
	base: "",
	enqueteId: "/:enqueteId",
	jobId: "/enquete/:jobId",
	templateId: "/template/:templateId",
} as const;
